import { render, staticRenderFns } from "./addRoleShop.vue?vue&type=template&id=67d316ed&scoped=true"
import script from "./addRoleShop.vue?vue&type=script&lang=js"
export * from "./addRoleShop.vue?vue&type=script&lang=js"
import style0 from "./addRoleShop.vue?vue&type=style&index=0&id=67d316ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d316ed",
  null
  
)

export default component.exports